import React, { useEffect, useState } from "react";

import removeCommas from "../../common/removeCommas";

import Table from "../../common/Table";
import Body from "../../components/Body";
import api from "../../config/api";
import { toast } from "react-toastify";
import { getPosGroupedByJob } from "../../stores/PoStore";
import { useQuery } from "@tanstack/react-query";

const header = [
  { name: "jobId", title: "Invoice ID" },
  { name: "subtotal", title: "Subtotal" },
  { name: "taxPercentage", title: "Tax" },
  { name: "total", title: "Total" },
  { name: "rTotal", title: "Right Total" },
  { name: "error", title: "Error" },
];
export default function JobErros() {
  const { data } = useQuery({
    queryFn: ()=>getPosGroupedByJob(),
    queryKey: ["jobs"],
  });
  if (!data) return false;
  return (
    <Body>
      <Table
        header={header}
        data={data.map((i) => {
          const rTotal = +Math.fround(
            +removeCommas(i.subtotal) * (1 + 0.01 * i.tax)
          ).toFixed(3);

          return {
            ...i,
            total: i.total,
            subtotal: i.subtotal,
            rTotal: rTotal,
            error: +removeCommas(rTotal) - +removeCommas(i.total),
          };
        })}
      />
    </Body>
  );
}
